angular.module('unergie.main')
.controller('contractTransferModalCtrl', ($scope, $uibModalInstance, TableGeneratorService, DataAccess, AlertManager, ErrorCatcher, contract) => {
    $scope.contract = contract

    $scope.targetAccounts = {
        show: {},
        refreshing: false,
        columns: {
            brand: { label: 'Compte', mode: 'search_wildcard' },
            id: { label: 'Id', mode: 'hidden' },
            external_id: { label: 'external_id', mode: 'search_wildcard' },
        },
        counts: [],
    }

    const filterExisting = (list) => {
        return _.filter(list, (l) => l.id !== $scope.contract.id_account)
    }

    TableGeneratorService.getTable($scope.targetAccounts, 'accounts', undefined, filterExisting, {
        search: {
            organization: $scope.contract.account.organization,
            groups: 'managed-account',
        },
    })

    $scope.toggleSelected = (a) => {
        _.each($scope.targetAccounts.instance.data, (elem) => {
            elem.selected = false
        })
        a.selected = true
    }

    $scope.getSelected = () => {
        return _.find($scope.targetAccounts.instance.data, { selected: true })
    }

    $scope.canTransfer = () => {
        return !!$scope.getSelected()
    }

    $scope.transfer = () => {
        $scope.transfering = true
        return DataAccess.transferContractOnAccount({ id_contract: contract.id, id_account: $scope.getSelected().id }, {}).$promise.then(() => {
            AlertManager.success('Contact transféré avec succès')
            contract.id_account = $scope.getSelected().id
            $scope.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.transfering = false
        })
    }

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()
})
